export const securityLevels = [
  "Not locked",
  "Elevated security",
  "EFI locked",
  "BIOS locked",
  "Icloud locked",
  "Activation lock",
];
